import { gql } from '@apollo/client'

export default gql(`
    mutation($id: ID! $project: String) {
        deleteAssetCategory(
            input: {
                id: $id
            }
            project: $project
        ) {
            id
            name
            slug
            assetCount
        }
    }`
)
